<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-button type="primary" @click="dialogAddVisible = true" style="width: 124px">新增一级菜单</el-button>
                </div>
            </div>
            <div>
                <el-table
                        :data="tableData"
                        v-loading="loading"
                        :header-cell-style="{'padding-left': '10%'}"
                        :cell-style="{'padding-left': '10%'}">
                    <el-table-column prop="sortNo" label="菜单排序"></el-table-column>
                    <el-table-column prop="menuCaption" label="一级菜单名称"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editCategory(scope.row)">编辑</el-button>
                            <el-button type="text" @click="openSecondary(scope.row)">次级分类</el-button>
                            <el-button type="text" class="delete-button" @click="deleteMenu(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog title="新增一级分类" :visible.sync="dialogAddVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="menuAdd" :rules="rules" ref="add" size="small">
                <el-form-item label="菜单名称:" label-width="100px" prop="menuCaption">
                    <el-input v-model="menuAdd.menuCaption" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="菜单排序:" label-width="100px" prop="sortNo">
                    <el-input v-model="menuAdd.sortNo" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="菜单地址:" label-width="100px" prop="urlAddress">
                    <el-input v-model="menuAdd.urlAddress" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="菜单logo:" label-width="100px" prop="icon">
                    <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                        <i class="el-icon-plus push"></i>
                        <el-image v-if="menuAdd.icon" class="course-img" :src="menuAdd.icon"></el-image>
                        <input type="file" class="upload-input" @change="addImg" accept="image/*" ref="picture"/>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑一级分类" :visible.sync="dialogEditVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="menuEdit" :rules="rules" ref="edit" size="small">
                <el-form-item label="菜单名称:" label-width="100px" prop="menuCaption">
                    <el-input v-model="menuEdit.menuCaption" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="菜单排序:" label-width="100px" prop="sortNo">
                    <el-input v-model="menuEdit.sortNo" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="菜单地址:" label-width="100px" prop="urlAddress">
                    <el-input v-model="menuEdit.urlAddress" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="菜单logo:" label-width="100px" prop="">
                    <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                        <i class="el-icon-plus push"></i>
                        <el-image v-if="menuEdit.icon" class="course-img" :src="menuEdit.icon"></el-image>
                        <input type="file" class="upload-input" @change="editImg" accept="image/*" ref="editPicture"/>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="次级分类" :visible.sync="secondaryVisible" width="520px">
            <div class="flex-box" style="margin: -20px 0 10px">
                <el-button plain @click="secondaryAddVisible = true">添加次级分类</el-button>
            </div>
            <el-table :data="secondaryData"
                      height="400px"
                      :header-cell-style="{'padding-left': '10%'}"
                      :cell-style="{'padding-left': '10%'}">
                <el-table-column prop="sortNo" label="菜单排序"></el-table-column>
                <el-table-column prop="menuCaption" label="二级菜单名称"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openSecondaryEdit(scope.row)">编辑</el-button>
                        <el-button type="text" class="delete-button" @click="deleteMenu(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="secondaryVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="secondaryVisible = false" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加次级分类" :visible.sync="secondaryAddVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelSecondaryAdd">
            <el-form :model="secondaryAdd" :rules="rules" ref="addSecondary" size="small">
                <el-form-item label="菜单名称:" label-width="100px" prop="menuCaption">
                    <el-input v-model="secondaryAdd.menuCaption" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="菜单排序:" label-width="100px" prop="sortNo">
                    <el-input v-model="secondaryAdd.sortNo" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="菜单地址:" label-width="100px" prop="urlAddress">
                    <el-input v-model="secondaryAdd.urlAddress" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelSecondaryAdd" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmSecondaryAdd" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑次级分类" :visible.sync="secondaryEditVisible" width="520px"
                   :close-on-click-modal="false" :before-close="cancelSecondaryEdit">
            <el-form :model="secondaryEdit" :rules="rules" ref="editSecondary" size="small">
                <el-form-item label="菜单名称:" label-width="100px" prop="menuCaption">
                    <el-input v-model="secondaryEdit.menuCaption" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="菜单排序:" label-width="100px" prop="sortNo">
                    <el-input v-model="secondaryEdit.sortNo" style="width: 282px"></el-input>
                </el-form-item>
                <el-form-item label="菜单地址:" label-width="100px" prop="urlAddress">
                    <el-input v-model="secondaryEdit.urlAddress" style="width: 282px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelSecondaryEdit" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmSecondaryEdit" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                // 表格信息
                loading: true,
                tableData: [],
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                // 新增弹窗数据
                menuAdd:{
                    sortNo: '',
                    menuCaption: '',
                    urlAddress: '',
                    icon: '',
                    leafFlag: '',
                },
                rules: {
                    menuCaption: [{required: true, message: '请输入菜单名称', trigger: 'blur'},],
                    sortNo: [{required: true, message: '请输入菜单排序', trigger: 'blur'},],
                    urlAddress: [{required: true, message: '请输入菜单地址', trigger: 'blur'},],
                    icon: [{required: true, message: '请选择菜单图标', trigger: 'blur'},],
                },
                // 编辑弹窗数据
                menuEdit:{},
                // 次级分类列表
                secondaryVisible: false,
                secondaryData: [],
                menuId: '',
                // 次级分类新增
                secondaryAddVisible: false,
                secondaryAdd: {
                    sortNo: '',
                    menuCaption: '',
                    urlAddress: '',
                    leafFlag: '',
                },
                // 次级分类编辑
                secondaryEditVisible: false,
                secondaryEdit: {
                    typeDetailName: ''
                }
            }
        },
        methods: {
            // 获取列表
            getData() {
                this.loading = true
                this.axios.get('/api-b/10025/100056',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.result_list !== null) {
                            this.tableData = res.data.data.result_list
                        } else {
                            this.$message.info('暂无数据')
                            this.tableData = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                    }
                    this.loading = false
                }).catch(() => {
                    this.tableData = []
                    this.loading = false
                })
            },
            // 取消新增
            cancelAdd() {
                this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },

            // 上传菜单logo
            uploadImg(data) {
                return new Promise(resolve => {
                    this.axios.post('/api-f/10027/100065',data,{
                        headers:{
                            Authorization: this.authorization,
                            'Content-Type':'multipart/form-data'
                        }
                    }).then(res => {
                        resolve(res)
                    })
                })
            },
            addImg(){
                let inputDOM = this.$refs.picture;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.menuAdd.icon = res.data.data.fileUrl
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 确定添加一级菜单
            confirmAdd() {
                // this.$refs.add.validate(valid => {
                //     if (valid) {
                        let params = {
                            sortNo: this.menuAdd.sortNo,
                            menuCaption: this.menuAdd.menuCaption,
                            urlAddress: this.menuAdd.urlAddress,
                            icon: this.menuAdd.icon,
                            leafFlag: '1'
                        }
                        this.axios.post('/api-b/10025/100058',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.dialogAddVisible = false
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields();
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                //     } else {
                //         this.$message.error('请按照要求正确填写相关信息')
                //     }
                // })

            },
            // 打开编辑弹窗
            editCategory(data) {
                this.menuEdit = data
                this.dialogEditVisible = true
            },
            // 取消修改
            cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
            // 修改图像
            editImg(){
                let inputDOM = this.$refs.editPicture;
                let file = inputDOM.files[0];
                let params = new FormData()
                params.append('file',file)
                this.uploadImg(params).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.menuEdit.icon = res.data.data.fileUrl
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 确认编辑一级菜单
            confirmEdit() {
                let params = {
                    menuId: this.menuEdit.menuId,
                    sortNo: this.menuEdit.sortNo,
                    menuCaption: this.menuEdit.menuCaption,
                    urlAddress: this.menuEdit.urlAddress,
                    icon: this.menuEdit.icon,
                }
                this.axios.put('/api-b/10025/100059',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogEditVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 打开次级分类列表
            openSecondary(data) {
                this.menuId = data.menuId
                this.secondaryData = data.children
                this.secondaryVisible = true
            },
            // 取消添加次级菜单
            cancelSecondaryAdd() {
                this.secondaryAddVisible = false
                this.$nextTick(() => {
                    this.$refs.addSecondary.resetFields()
                })
            },
            // 确认添加次级菜单
            confirmSecondaryAdd() {
                this.$refs.addSecondary.validate(valid => {
                    if (valid) {
                        let params = {
                            pMenuId: this.menuId,
                            sortNo: this.secondaryAdd.sortNo,
                            menuCaption: this.secondaryAdd.menuCaption,
                            urlAddress: this.secondaryAdd.urlAddress,
                            leafFlag: '1'
                        }
                        this.axios.post('/api-b/10025/100058',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.secondaryAddVisible = false
                                this.secondaryVisible = false
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.addSecondary.resetFields();
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },
            // 打开编辑次级菜单
            openSecondaryEdit(data) {
                this.secondaryEditVisible =true
                this.secondaryEdit = data
            },
            // 取消编辑
            cancelSecondaryEdit() {
                this.secondaryEditVisible = false
                this.$nextTick(() => {
                    this.$refs.editSecondary.clearValidate()
                })
            },
            // 编辑次级菜单
            confirmSecondaryEdit() {
                let params = {
                    menuId: this.secondaryEdit.menuId,
                    sortNo: this.secondaryEdit.sortNo,
                    menuCaption: this.secondaryEdit.menuCaption,
                    urlAddress: this.secondaryEdit.urlAddress,
                }
                this.axios.put('/api-b/10025/100059',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.secondaryEditVisible = false
                        this.secondaryVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 删除菜单
            deleteMenu(date) {
                this.axios.delete('/api-b/10025/100061/' + date.menuId,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res =>{
                    if(res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.secondaryVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }
        },
        created() {
            this.getData()
        }
    }

</script>
<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .flex-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }
    .push {
        color:rgba(238,238,238,1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }
    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }
    .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>